import * as GeneralRepository from "./general-repository";
import * as FirmaProvider from "../providers/firma-provider";

export const registrarFirma = async (idSolicitudMultiple, metodoFirma, usuario) => {
    const response = await FirmaProvider.registrarFirma({
       datos: {
        idSolicitudMultiple: idSolicitudMultiple,
        signingMethod: metodoFirma,
        usuario: usuario,
       }
      })

    if(response && response.datos !== undefined && response.datos !== null) {
        return {
            error: null,
            firma: response.datos
        }
    } else {
        return {
            error: response,
            firma: null
        }
    }
}